import { ApprovalEntry } from '../../../api/entries';
import { cn } from '../../../lib/utils';
import { ROLE_LABEL, ROLE_COLOR } from './utils';

// ─── Role badge ───────────────────────────────────────────────────────────────

export function RoleBadge({ role }: { role: ApprovalEntry['callerRole'] }) {
  return (
    <span className={cn('text-xs font-medium px-2 py-0.5 rounded-full', ROLE_COLOR[role])}>
      {ROLE_LABEL[role]}
    </span>
  );
}
